// src/config/quillConfig.ts

import type { QuillToolbarConfig } from './quillTypes';

/**
 * Default toolbar configuration for React Quill.
 * Set a property to `false` to disable that feature.
 * For features with multiple options (like header, list, color, align),
 * provide an array of desired values.
 *
 * Use `toolbarOrder` to customize the order of toolbar groups:
 * Available groups: 'formatting', 'header', 'font-size', 'list', 'color', 'align', 'media', 'blocks', 'clean'
 */
export const DEFAULT_TOOLBAR_CONFIG: QuillToolbarConfig = {
  bold: true,
  italic: true,
  underline: true,
  strike: true,
  font: false, // Enable all fonts
  size: false, // Enable all sizes (small, normal, large, huge)
  color: true, // Enable full color picker with all colors
  background: true,
  align: ['', 'center', 'right', 'justify'],
  header: [],
  list: ['ordered', 'bullet'],
  link: false,
  image: true,
  video: false, // Disabled by default
  blockquote: false,
  'code-block': false,
  clean: false, // Remove formatting

  // Customize toolbar order (optional)
  // If not specified, default order will be used
  toolbarOrder: [
    'font-size',
    'header',
    'formatting',
    'list',
    'align',
    'color',
    'media',
    'blocks',
    'clean',
  ],
};
